<template>
    <div :id="id" :style="chartStyle"></div>
</template>

<script>
/**
 * ECharts 饼图组件
 * @description 用于展示分类占比数据
 */
import * as echarts from 'echarts';

export default {
    name: 'EchartPie',
    
    data() {
        return {
            chart: null // ECharts 实例
        };
    },
    
    props: {
        // 图表 ID
        id: {
            type: String,
            default: 'pie'
        },
        // 图表宽度
        width: {
            type: String,
            default: '100%'
        },
        // 图表高度
        height: {
            type: [String, Number],
            default: 400
        },
        // 图表标题
        title: {
            type: String,
            default: '数据统计'
        },
        // 饼图名称
        name: {
            type: String,
            default: '统计数据'
        },
        // 饼图数据
        data: {
            type: Array,
            default: () => [
                { value: 1048, name: '搜索引擎' },
                { value: 735, name: '直接访问' },
                { value: 580, name: '邮件营销' },
                { value: 484, name: '联盟广告' },
                { value: 300, name: '视频广告' }
            ]
        }
    },
    
    computed: {
        /**
         * 计算图表样式
         */
        chartStyle() {
            const height = typeof this.height === 'number' ? `${this.height}px` : this.height;
            return {
                height: height,
                width: this.width
            };
        }
    },
    
    mounted() {
        this.initChart();
    },
    
    beforeDestroy() {
        // 组件销毁前，清理 ECharts 实例，防止内存泄漏
        this.disposeChart();
    },
    
    methods: {
        /**
         * 初始化图表
         */
        initChart() {
            // 获取 DOM 元素
            const chartDom = document.getElementById(this.id);
            
            // 检查 DOM 是否存在
            if (!chartDom) {
                console.error(`❌ Chart DOM element with id "${this.id}" not found`);
                return;
            }
            
            // 初始化 ECharts 实例
            this.chart = echarts.init(chartDom);
            
            // 配置图表选项
            const option = {
                title: {
                    text: this.title,
                    left: 'center',
                    textStyle: {
                        fontSize: 16,
                        fontWeight: 'normal'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(50, 50, 50, 0.8)',
                    textStyle: {
                        color: '#fff'
                    },
                    formatter: '{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    top: 'middle'
                },
                series: [
                    {
                        name: this.name,
                        type: 'pie',
                        radius: ['40%', '70%'], // 环形饼图
                        center: ['50%', '50%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 4,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            formatter: '{b}: {d}%'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            },
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: this.data,
                        animationType: 'scale',
                        animationEasing: 'elasticOut',
                        animationDelay: function (idx) {
                            return Math.random() * 200;
                        }
                    }
                ]
            };
            
            // 设置图表配置
            this.chart.setOption(option);
            
            // 监听窗口变化，自动调整图表大小
            this.handleResize();
        },
        
        /**
         * 处理窗口大小变化
         */
        handleResize() {
            if (this.chart) {
                this.chart.resize();
            }
        },
        
        /**
         * 销毁图表实例
         */
        disposeChart() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
        }
    }
};
</script>
